export const prodCfg = {
  env: 'prod',
  cdn: 'https://rcdn.kervinteractive.com/',
  dc: 'https://dc.grabit.video/cache/data',
  trackingAPI: 'https://grabit.video/api/',
  apps: {
    player:{
      css:'https://rcdn.kervinteractive.com/overlay/v3/prod/kerv-player.css',
      js:'https://rcdn.kervinteractive.com/overlay/v3/prod/kerv-player.js'
    },
    overlay: {
      css:'https://rcdn.kervinteractive.com/overlay/v3/prod/kerv-embed.css',
      js:'https://rcdn.kervinteractive.com/overlay/v3/prod/kerv-embed.js'
    },
    social: {
      css:'https://rcdn.kervinteractive.com/overlay/v3/prod/kerv-social.css',
      js:'https://rcdn.kervinteractive.com/overlay/v3/prod/kerv-social.js'
    },
    connect: {
      css:'https://rcdn.kervinteractive.com/overlay/v3/prod/connect/kerv-connect.css',
      js:'https://rcdn.kervinteractive.com/overlay/v3/prod/connect/kerv-connect.js'
    }
  },
  cachedApi: 'https://radius.video/v1/creatives/',
  api: 'https://dcdn.radius.video/v1/creatives/',
}

export const qaCfg = {
  env: 'qa',
  cdn: 'https://rcdn.kervinteractive.com/',
  dc: 'https://dc-stg.grabit.video/cache/data',
  trackingAPI: 'https://stg.grabit.video/api/',
  apps: {
    player:{
      css:'https://rcdn.kervinteractive.com/overlay/v3/qa/kerv-player.css',
      js:'https://rcdn.kervinteractive.com/overlay/v3/qa/kerv-player.js'
    },
    overlay: {
      css:'https://rcdn.kervinteractive.com/overlay/v3/qa/kerv-embed.css',
      js:'https://rcdn.kervinteractive.com/overlay/v3/qa/kerv-embed.js'
    },
    social: {
      css:'https://rcdn.kervinteractive.com/overlay/v3/qa/kerv-social.css',
      js:'https://rcdn.kervinteractive.com/overlay/v3/qa/kerv-social.js'
    },
    connect: {
      css:'https://rcdn.kervinteractive.com/overlay/v3/qa/connect/kerv-connect.css',
      js:'https://rcdn.kervinteractive.com/overlay/v3/qa/connect/kerv-connect.js'
    }
  },
  cachedApi: 'https://qa.radius.video/v1/creatives/',
  api: 'https://qa.radius.video/v1/creatives/',
}

export const stgCfg = {
  env: 'stg',
  cdn: 'https://rcdn.kervinteractive.com/',
  dc: 'https://dc-stg.grabit.video/cache/data',
  trackingAPI: 'https://stg.grabit.video/api/',
  apps: {
    player:{
      css:'https://rcdn.kervinteractive.com/overlay/v3/stg/kerv-player.css',
      js:'https://rcdn.kervinteractive.com/overlay/v3/stg/kerv-player.js'
    },
    overlay: {
      css:'https://rcdn.kervinteractive.com/overlay/v3/stg/kerv-embed.css',
      js:'https://rcdn.kervinteractive.com/overlay/v3/stg/kerv-embed.js'
    },
    social: {
      css:'https://rcdn.kervinteractive.com/overlay/v3/stg/kerv-social.css',
      js:'https://rcdn.kervinteractive.com/overlay/v3/stg/kerv-social.js'
    },
    connect: {
      css:'https://rcdn.kervinteractive.com/overlay/v3/stg/connect/kerv-connect.css',
      js:'https://rcdn.kervinteractive.com/overlay/v3/stg/connect/kerv-connect.js'
    }
  },
  cachedApi: 'https://stg.radius.video/v1/creatives/',
  api: 'https://stg.radius.video/v1/creatives/',
}

export const localCfg = {
  env: 'local',
  cdn: 'https://rcdn.kervinteractive.com/',
  dc: 'https://dc.grabit.video/cache/data',
  trackingAPI: 'https://stg.grabit.video/api/',
  css:'kerv-embed.css',
  apps: {
    player:{
      css:'http://localhost:4173/kerv-player.css',
      js:'http://localhost:4173/kerv-player.js'
    },
    overlay: {
      css:'http://localhost:8888/kerv-embed.css',
      js:'http://localhost:8888/kerv-embed.js'
    },
    social: {
      css:'https://localhost:5173/kerv-social.css',
      js:'https://localhost:5173/kerv-social.js'
    },
    connect: {
      css:'https://localhost:4174/kerv-connect.css',
      js:'https://localhost:4174/kerv-connect.js'
    }
  },
  cachedApi: 'http://localhost:8080/v1/creatives/',
  api: 'https://qa.radius.video/v1/creatives/',
}
